import React from 'react';
import { Sidebar } from '../../components/shared/Sidebar';
import { DashboardHeader } from '../../components/shared/DashboardHeader';
import { CertificateCard } from '../../components/certificates/CertificateCard';
import { MOCK_CERTIFICATES } from '../../utils/mockData';
import { motion } from 'framer-motion';
import { ShieldCheck, CheckCircle } from 'lucide-react';
export function RentCertificate() {
  const certificate = MOCK_CERTIFICATES[0];
  return <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pb-16 lg:pb-0" data-id="element-4906">
      <Sidebar data-id="element-4907" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-4908">
        <DashboardHeader data-id="element-4909" />

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8" data-id="element-4910">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-4911">
            <div className="mb-8 text-center" data-id="element-4912">
              <div className="inline-flex items-center justify-center p-3 bg-blue-100 dark:bg-blue-900/30 rounded-full mb-4" data-id="element-4913">
                <ShieldCheck className="h-8 w-8 text-blue-600 dark:text-blue-400" data-id="element-4914" />
              </div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-4915">
                Your Rent Certificate
              </h1>
              <p className="mt-2 text-sm text-gray-500 dark:text-gray-400 max-w-lg mx-auto break-words" data-id="element-4916">
                Use this certificate to prove your rent reliability to new
                landlords or for official purposes. It acts as a guarantee that
                Renta services your payments.
              </p>
            </div>

            <CertificateCard certificate={certificate} data-id="element-4917" />

            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6" data-id="element-4918">
              {[{
              title: 'Verified Status',
              desc: 'Proves your identity and tenancy status.'
            }, {
              title: 'Payment Guarantee',
              desc: 'Shows Renta backs your rent payments.'
            }, {
              title: 'Instant Verification',
              desc: 'Landlords can scan QR code to verify.'
            }].map((item, idx) => <div key={idx} className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm flex items-start transition-colors" data-id="element-4919">
                  <CheckCircle className="h-5 w-5 text-green-500 dark:text-green-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-4920" />
                  <div className="min-w-0" data-id="element-4921">
                    <h3 className="text-sm font-medium text-gray-900 dark:text-white truncate" data-id="element-4922">
                      {item.title}
                    </h3>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 break-words" data-id="element-4923">
                      {item.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>
      </main>
    </div>;
}